module.exports = __webpack_public_path__ + "static/media/pixabay2.41fce095.png";